export var MissingChoicesEnum;
(function (MissingChoicesEnum) {
    MissingChoicesEnum[MissingChoicesEnum["Compare"] = 0] = "Compare";
    MissingChoicesEnum[MissingChoicesEnum["PrivateBenchmark"] = 1] = "PrivateBenchmark";
})(MissingChoicesEnum || (MissingChoicesEnum = {}));
